// extracted by mini-css-extract-plugin
export var previewContainer = "_so-0";